var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75824 27.7612C5.75824 28.5405 6.39585 29.1781 7.17515 29.1781H12.8428C13.6221 29.1781 14.2597 28.5405 14.2597 27.7612V26.3443H5.75824V27.7612ZM10.009 0.839813C4.53969 0.839813 0.0905762 5.28893 0.0905762 10.7582C0.0905762 14.1305 1.77671 17.0918 4.34132 18.8913V22.0935C4.34132 22.8728 4.97893 23.5105 5.75824 23.5105H14.2597C15.039 23.5105 15.6766 22.8728 15.6766 22.0935V18.8913C18.2413 17.0918 19.9274 14.1305 19.9274 10.7582C19.9274 5.28893 15.4783 0.839813 10.009 0.839813ZM14.0472 16.5676L12.8428 17.4177V20.6766H7.17515V17.4177L5.97077 16.5676C5.03205 15.9168 4.26472 15.0486 3.73425 14.037C3.20378 13.0254 2.92593 11.9005 2.92441 10.7582C2.92441 6.84753 6.0983 3.67364 10.009 3.67364C13.9197 3.67364 17.0936 6.84753 17.0936 10.7582C17.0936 13.0678 15.96 15.2357 14.0472 16.5676Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicon);
export default __webpack_public_path__ + "static/media/bicon.24c21938d51f2464712db1ab4a810cbd.svg";
export { ForwardRef as ReactComponent };